import store from '../store/store';
import i18n from '../i18n';
import { actions as _act } from '@/models/store.actions';

export function getLocale(key, values?: any) {
  return i18n.t(key, store.getters[_act.SETT_GET_LOCALEGET], values);
}

export function getLocaleR(key, lang, values?: any) {
  return i18n.t(key, lang, values);
}
